/**
 * @fileoverview Component for displaying a staff menu item.
 * This component includes a link to a specific route and displays an icon and title.
 */

import { useMatches } from 'react-router-dom'

import StaffIcon from '../../assets/menu/staff.svg'
import PlusIcon from '../../assets/plus.svg'
import { useModal } from '../../hooks/useModal'
import { NewParticipant } from '../modals/content/NewParticipant'
import { MenuItem } from './MenuItem'

/**
 * @function StaffMenuItem
 * @description Component for displaying a staff menu item.
 * @returns {JSX.Element} - A React component that renders the staff menu item.
 */
export function StaffMenuItem() {
    const [open] = useModal()
    const matches = useMatches()

    const fullUrl = matches[matches.length - 1].pathname

    // TODO: Remove false && when manual staff creation is implemented
    const areStudiesSelected = false && Boolean(fullUrl.match(/\/app\/staff/))

    return (
        <>
            <div className="relative flex flex-col">
                <MenuItem
                    isActive={areStudiesSelected}
                    icon={StaffIcon}
                    title="Staff"
                    to="/app/staff"
                />

                {areStudiesSelected && (
                    <button
                        onClick={() => open({ content: <NewParticipant /> })}
                        className="absolute w-8 h-8 transition-all bg-indigo-100 hover:bg-indigo-200 flex justify-center items-center rounded-md p-1 right-2 top-2"
                    >
                        <PlusIcon className="w-5 h-5 fill-indigo-500" />
                    </button>
                )}
            </div>
        </>
    )
}
